import { Route } from "react-router-dom";

import ProfilePage from "../pages/ProfilePage";

export const profilePage = <Route path="profile/:userId" element={<ProfilePage />} />;
